import request from '@/utils/request'

export function add(data) {
    return request({
        url: 'api/species',
        method: 'post',
        data
    })
}

export function doSubmitType(data) {
    return request({
        url: 'api/setMealType',
        method: 'post',
        data
    })
}

export function putSubmitType(data) {
    return request({
        url: 'api/setMealType',
        method: 'put',
        data
    })
}


export function del(id) {
    return request({
        url: 'api/species/' + id,
        method: 'delete'
    })
}

export function edit(data) {
    return request({
        url: 'api/species',
        method: 'put',
        data
    })
}

export function getSpecies() {
    return request({
        url: 'api/species',
        method: 'get'
    })
}

export function setMealTypeAll() {
    return request({
        url: 'api/setMealTypeAll',
        method: 'get'
    })
}

export function getTypeAll() {
    return request({
        url: 'api/species?page=0&size=999&sort=id,desc',
        method: 'get'
    })
}
